import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import { useBreakpointValue } from 'utils/mediaQuery';
import { useConversationSidebarSettings } from 'utils/useConversationSidebarSettings';

export const ConversationHeaderSidebarOpenButton = (): JSX.Element | null => {
  const { isSidebarOpen, setSidebarOpen } = useConversationSidebarSettings();
  const shouldButtonBeVisible = useBreakpointValue({ base: true, lg: false });

  return shouldButtonBeVisible ? (
    <Tooltip content={'Show information'}>
      <IconButton
        data-testid="show-information-button"
        icon="bars"
        variant="tertiary"
        active={isSidebarOpen}
        onClick={() => setSidebarOpen(true)}
      />
    </Tooltip>
  ) : null;
};
